export const EnglishText = {
    // Navigation and shared task page labels
    myDepartmentTitle: "My Department",
    myTeamTitle: "My Team",
    myTaskTitle: "My Task",
    assignedTaskTitle: "Assigned Tasks",
    taskAssignedByMeTitle: "Tasks Assigned By Me",
    myTaskListTitle: "My Task List",
    taskNavigationTitle: "Task Navigation",
    taskDateLocale: "en-US",
    taskMonthNames: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ],
    assignTaskTitle: "Assign Task",
    assignTaskButton: "Create Task",
    createTaskTitle: "Create Task",
    editTaskTitle: "Edit Task",
    myWorkTitle: "My Work",
    myWorkSubtitle: "Stay focused. Stay consistent. Results will follow.",
    myDepartmentSubtitle: "Review your reporting line, direct reports, and department task shortcuts.",
    departmentOverviewTitle: "Department Overview",
    departmentOverviewSubtitle: "Summary is based on the organization reporting structure.",
    departmentTeamsSubtitle: "Team members and department structure will be shown here.",
    departmentLoadError: "Unable to load department information.",
    departmentCurrentPerson: "Current Person",
    departmentDirectReports: "Direct Reports",
    departmentTotalReports: "Total Reports",
    departmentUnderCommandTitle: "Under Command",
    departmentNoDirectReports: "No direct reports found under you.",
    departmentTheirReports: "Their reports",
    departmentTopLevel: "Top of organization",
    departmentNotAssigned: "Not assigned",
    departmentNoEmployeeId: "No employee ID",
    departmentGENERAL: "General",
    departmentTECHNICAL: "Technical",
    departmentMARKETING: "Marketing",
    departmentSALES: "Sales",
    departmentADMIN: "Admin",
    positionBOSS: "Boss",
    positionGENERAL_MANAGER: "General Manager",
    positionMANAGER: "Manager",
    positionASSISTANT_MANAGER: "Assistant Manager",
    positionEXECUTIVE: "Executive",
    positionADMIN: "Admin",
    noTaskFound: "No task found",
    noRecordsFound: "No records",
    askManagerTaskMessage: "Ask your manager to assign task for you.",
    cdpLoading: "Loading...",
    searchButton: "Search",
    resetButton: "Reset",
    previousButton: "Previous",
    nextButton: "Next",
    cancelManagingUser: "Cancel",
    cdpCancelBtn: "Cancel",
    cdpDeleteConfirmTitle: "Delete Confirmation",
    saveDataButton: "Save",
    saveChangesButton: "Save Changes",
    editButton: "Edit",
    deleteButton: "Delete",
    commentButton: "Comment",

    // Filters, table columns, and stats
    selectYearLabel: "Year",
    selectMonthLabel: "Month",
    selectProjectAll: "All Projects",
    selectCurrentYearLabel: "Current Year",
    selectLastYearLabel: "Last Year",
    searchTaskPlaceholder: "Search task, project, assignee...",
    taskSubmissionTimeLabel: "Submission Time",
    taskProjectLabel: "Project",
    taskProjectSelectPlaceholder: "Select project",
    taskProjectCreateButton: "New Project",
    taskProjectNamePrompt: "Project name:",
    taskProjectDetailsPrompt: "Project details:",
    taskOriginalDueDateLabel: "Original Due Date",
    taskCurrentDueDateLabel: "Current Due Date",
    taskCompletionDateLabel: "Completion Date",
    taskMarkDone: "Done",
    taskColId: "Task ID",
    taskColName: "Task Name",
    taskColTitle: "Title",
    taskColTask: "Task",
    taskColAssigner: "Assigner",
    taskColAssignee: "Assignee",
    taskColReceiver: "Receiver",
    taskColPriority: "Priority",
    taskColDueDate: "Due Date",
    taskColStatus: "Status",
    taskColAction: "Action",
    taskFilterReceiverAll: "Receiver: All",
    taskFilterAssigneeAll: "Assignee: All",
    taskFilterPriorityHighest: "Priority: Highest",
    taskFilterStatusAll: "Status: All",
    taskTotalAssignedLabel: "Tasks Assigned",
    taskCompletionScoreLabel: "Completion Score",
    taskFoundCountSingular: "task found",
    taskFoundCountPlural: "tasks found",
    paginationShowing: "Showing",
    paginationOf: "of",
    paginationPage: "Page",

    // Task type, priority, and status labels
    taskTypeLabel: "Task Type",
    taskTypeGeneral: "General",
    taskTypeProduct: "Product",
    taskTypeMfgProduct: "MFG Product",
    taskTypeCustomer: "Customer",
    taskTypeContact: "Contact",
    taskPriorityLow: "Low",
    taskPriorityMedium: "Medium",
    taskPriorityHigh: "High",
    taskPriorityUrgent: "Urgent",
    taskStatusDraft: "Draft",
    taskStatusAssigned: "Assigned",
    taskStatusInProgress: "In Progress",
    taskStatusSubmitted: "Submitted",
    taskStatusUnderReview: "Under Review",
    taskStatusCompleted: "Completed",
    taskStatusDone: "Done",
    taskStatusOnHold: "On Hold",
    taskStatusCancelled: "Cancelled",
    taskStatusGivenUp: "Given Up",
    taskStatusLate: "Late",
    taskStatusOverdue: "Overdue",
    taskStatusResolution: "Resolution",

    // Create and edit task form
    createTaskSubtitle: "Create or select a project first, then define the task that can be assigned later.",
    editTaskSubtitle: "Update the task details and save changes.",
    createTaskPanelHint: "Select a project to enable the task fields.",
    taskCreatedByLabel: "Task Created By",
    currentUserFallback: "Current user",
    createProjectButton: "Create Project",
    selectProjectButton: "Select Project",
    noProjectSelected: "No project selected",
    noProjectsFound: "No projects found.",
    noProjectLabel: "No project",
    noProjectDescription: "No description provided.",
    taskNameLabel: "Task Name",
    taskNamePlaceholder: "Write a clear one-line task name",
    taskDescriptionLabel: "Description",
    taskDescriptionPlaceholder: "Task description",
    taskAttachments: "Attachments",
    createProjectTitle: "Create Project",
    selectProjectTitle: "Select Project",
    creatorLabel: "Creator",
    projectNameLabel: "Project Name",
    projectNamePlaceholder: "Project name",
    projectDetailsLabel: "Project Details",
    projectDetailsPlaceholder: "Short project context",
    creatingTaskLabel: "Creating task...",
    savingTaskLabel: "Saving task...",
    creatingProjectLabel: "Creating...",
    loadingProjectsLabel: "Loading projects...",
    loadingLabel: "Loading...",

    // Assign task page and drawer
    assignTaskSubtitle: "Choose an existing task, review the details, then assign it to the right person with deadlines and remarks.",
    chooseTaskTitle: "Choose Task",
    loadingAssignmentData: "Loading task assignment data...",
    loadingTasksLabel: "Loading tasks...",
    unableLoadAssignmentData: "Unable to load task assignment data.",
    unableSaveAssignment: "Unable to save this assignment.",
    taskDetailsAriaLabel: "Task assignment details",
    taskDescriptionEmpty: "No description.",
    taskDescriptionEmptyShort: "No description",
    addAssignmentTitle: "Add Assignment",
    editAssignmentTitle: "Edit Assignment",
    assigneesLabel: "Assignees",
    assignerLabel: "Assigner",
    selectAssigneePlaceholder: "Select assignee",
    remarksLabel: "Remarks",
    assignmentRemarksPlaceholder: "Add assignment notes, expectations, or handoff details.",
    savingAssignmentLabel: "Saving assignment...",
    assigningTaskLabel: "Assigning task...",
    assignTaskSubmitButton: "Assign Task",
    savingLabel: "Saving...",
    assigningLabel: "Assigning...",

    // Task details modal, history, comments, and delete assignment
    taskDetailsAria: "Task details",
    taskDescriptionTitle: "Task Description",
    taskHistoryTitle: "Task History",
    taskCreatedHistoryLabel: "Task Created",
    taskAssignedHistoryLabel: "Task Assigned",
    requestedDueDateHistoryLabel: "Requested Due Date",
    reviewedHistoryLabel: "Reviewed",
    submitYourTaskTitle: "Submit Your Task",
    commentsTitle: "Comments",
    noCommentsYet: "No comments yet.",
    commentPlaceholder: "Write a comment...",
    postingCommentLabel: "Posting comment...",
    postingLabel: "Posting...",
    submittingTaskLabel: "Submitting task...",
    approvingSubmissionLabel: "Approving submission...",
    rejectingSubmissionLabel: "Rejecting submission...",
    deletingAssignmentLabel: "Deleting assignment...",
    failedSubmitTaskResult: "Failed to submit task result.",
    failedApproveSubmission: "Failed to approve submission.",
    failedRejectSubmission: "Failed to reject submission.",
    failedDeleteAssignment: "Failed to delete this assignment.",
    taskDeleteAssignmentTitle: "Delete Assignment",
    taskDeleteAssignmentMessagePrefix: "This will delete the assignment for",
    taskDeleteAssignmentMessageSuffix: "Any screenshots in the assignment remarks will also be removed.",
    thisAssigneeLabel: "this assignee",
    closeTaskDetailsLabel: "Close task details",
    closeDeleteConfirmationLabel: "Close delete confirmation",
    taskImagePreviewAlt: "Task image preview",

    // Submission and review
    taskSubmitResultTitle: "Submit Task Result",
    submissionTypeFinal: "Final Submission",
    submissionTypeResolution: "Resolution Request",
    submissionTypeModification: "Content Modification Request",
    submissionTypeGiveUp: "Give Up Request",
    submissionRemarksLabel: "Remarks",
    submissionRemarksRequired: "Remarks are required.",
    submissionResolutionDateLabel: "Resolution Date",
    submissionResolutionDateRequired: "Resolution date is required.",
    submissionRequestedDueDateLabel: "Requested Due Date",
    submissionSubmitButton: "Submit",
    submissionListTitle: "Task Submissions",
    submissionColSubmitter: "Submitter",
    submissionColType: "Type",
    submissionApproveButton: "Approve",
    submissionRejectButton: "Reject",
    submissionRejectRemarksPrompt: "Enter review remarks for rejection:",
    submissionReviewRemarksLabel: "Review Remarks",
    submissionReviewPlaceholder: "Add approval or rejection remarks...",
    rejectingLabel: "Rejecting...",

    // Legacy task form and linked data labels
    taskDueDateInputLabel: "Due Date",
    taskDueTimeInputLabel: "Due Time",
    taskDueHourInputLabel: "Hour",
    taskDueMinuteInputLabel: "Minute",
    taskLinkedDataLabel: "Task Details",
    taskAssigneePlaceholder: "Task assignee",
    taskRequiredAlertPrefix: "Please fill in",
    cdpFormAttachments: "Attachment",
    taskPreviewAttachment: "Preview",
    taskSearchTitleProduct: "Search Product",
    taskSearchTitleMfgProduct: "Search MFG Product",
    taskSearchTitleCustomer: "Search Customer",
    taskSearchTitleContact: "Search Contact",
    taskSelectedItemsTitle: "Selected Items",
    taskModifySelectionButton: "Modify Selection",
    pnProductName: "Name",
    pnProductRemarks: "Remarks",
    contactImageLabel: "Profile",
    contactCompanyLabel: "Company",
    customerLogoLabel: "Logo",
    customerProductsLabel: "Products",
    taskDeleteButton: "Delete Task",
    taskDeleteConfirmMessage: "Are you sure you want to delete this task?",
    taskUpdateStatusButton: "Update Status",
    taskActionsLabel: "Task actions",
    taskAssignPrompt: "Wanna assign task to someone?",
    taskOpenFormBtn: "Open the form and send the task.",
    taskInsertScreenshot: "Insert Screenshot",
    taskCloseEditor: "Close the Editor",
    taskAssignmentIdLabel: "Assignment ID",
    taskAssignedAtLabel: "Assigned At",
    taskRemarksLabel: "Assignment Remarks"
};
